{
  "en": {
    "headlines": {
      "admin": {
        "blueprints": {
          "index": "Blueprints",
          "materials": "Materials",
          "stats": "Stats",
          "sources": "Sources"
        },
        "missions": {
          "index": "Missions"
        },
        "dashboard": {
          "title": "Dashboard",
          "visitsPerDay": "Visits per Day",
          "visitsPerMonth": "Visits per Month",
          "mostViewedPages": "Most Viewed Pages",
          "registrationsPerMonth": "Registrations per Month",
          "catalogue": "Catalogue Build",
          "recentEdits": "Recent Admin Edits"
        },
        "models": {
          "index": "Models",
          "edit": {
            "index": "Edit Model",
            "fleetchart": "Fleetchart Images",
            "positions": "Crew Positions",
            "hardpoints": "Hardpoints",
            "cargoAndFuel": "Fuel",
            "cargoHolds": "Cargo Holds",
            "metrics": "Metrics",
            "prices": "Prices",
            "docks": "Docks",
            "modules": "Modules",
            "paints": "Paints",
            "videos": "Videos",
            "images": "Images",
            "itemPrices": "Item Prices",
            "linkModule": "Link Existing Module",
            "loaners": "Loaners",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Upgrades",
            "packages": "Packages",
            "linkUpgrade": "Link Existing Upgrade",
            "history": "History"
          },
          "new": "New Model",
          "show": "Model",
          "images": "Images",
          "tableConfigurationModal": "Table Configuration"
        },
        "components": {
          "index": "Components",
          "new": "New Component",
          "edit": {
            "index": "Edit Component",
            "itemPrices": "Item Prices",
            "history": "History"
          }
        },
        "modelPaints": {
          "index": "Paints",
          "new": "New Paint",
          "edit": "Edit Paint",
          "copy": "Copy Paint to Ship",
          "bulkCopy": "Copy %{count} Paints to Ship"
        },
        "modelModules": {
          "index": "Modules",
          "new": "New Module",
          "edit": "Edit Module",
          "models": "Linked Models",
          "prices": "Prices",
          "hardpoints": "Hardpoints",
          "docks": "Docks",
          "cargoHolds": "Cargo Holds",
          "history": "History"
        },
        "unlistedModels": {
          "index": "Ships in the game files with no model",
          "link": "Link to a ship in the catalogue"
        },
        "manufacturers": {
          "index": "Manufacturers",
          "new": "New Manufacturer",
          "edit": {
            "index": "Edit Manufacturer"
          }
        },
        "announcements": {
          "index": "Announcements",
          "new": "New Announcement",
          "edit": "Edit Announcement",
          "deliveries": "Delivery"
        },
        "supporterContributions": {
          "index": "Supporter Contributions",
          "new": "New Supporter Contribution",
          "edit": "Edit Supporter Contribution",
          "perMonth": "Contributions per Month"
        },
        "fundingGoals": {
          "index": "Funding Goals",
          "new": "New Funding Goal",
          "edit": "Edit Funding Goal"
        },
        "users": {
          "index": "Users",
          "edit": "Edit User",
          "fleets": "Fleets",
          "inventories": "Inventories",
          "supporterContributions": "Supporter Contributions"
        },
        "vehicles": {
          "index": "Vehicles",
          "edit": "Edit Vehicle"
        },
        "fleets": {
          "index": "Fleets",
          "edit": "Edit Fleet",
          "members": "Members",
          "memberEdit": "Edit Member",
          "history": "History",
          "roles": "Roles",
          "inventories": "Inventories",
          "inventoryItems": "Entries"
        },
        "destroyedFleets": {
          "index": "Destroyed Fleets"
        },
        "admins": {
          "index": "Admins",
          "new": "New Admin",
          "edit": "Edit Admin"
        },
        "oauthApplications": {
          "index": "OAuth Applications",
          "new": "New OAuth Application",
          "edit": "Edit OAuth Application",
          "reject": "Refuse %{name}",
          "rejectBulk": "Refuse %{count} applications"
        },
        "features": {
          "index": "Feature Flags",
          "show": "Feature Details",
          "globalState": "Global State",
          "groups": "Groups",
          "actors": "Actors",
          "selfService": "Self-Service",
          "percentageOfActors": "Percentage of Actors",
          "percentageOfTime": "Percentage of Time",
          "addActor": "Add Actor",
          "history": "History"
        },
        "rsiApiStatus": {
          "index": "RSI API Status"
        },
        "images": {
          "index": "Images"
        },
        "imports": {
          "index": "Imports"
        },
        "notifications": {
          "index": "Notifications"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "itemPrices": "Item Prices"
          }
        },
        "visualTests": {
          "index": "Visual Tests",
          "notifications": "Notifications"
        },
        "buildCompare": {
          "index": "Build Compare"
        }
      },
      "welcome": "Welcome to",
      "welcomeShips": "Latest Ships",
      "welcomeImages": "Random Images",
      "ships": {
        "index": "Ships Index",
        "fleetchart": "Ships Fleetchart"
      },
      "images": "Images Index",
      "stats": "Stats",
      "notFound": "Navigation Error",
      "forbidden": "Access Denied",
      "subscriptionRequired": "Supporter Feature",
      "featureNotReady": "Coming Soon",
      "inviteInvalid": "Invalid Invite Link",
      "accessDenied": "Access Denied",
      "serverError": "Server Error",
      "offline": "Connection Lost",
      "invalidRequest": "Invalid Request",
      "comments": "Comments",
      "login": "Login",
      "hangar": {
        "index": "My Hangar",
        "preview": {
          "h1": "My Hangar Preview",
          "h2": "Your personal Hangar requires an FleetYards.net Account",
          "h3": "What Features does the Hangar include?"
        },
        "alternativeNames": "Alternative Names",
        "stats": "Stats",
        "public": "%{user} Hangar",
        "import": "Import",
        "wishlist": "Wishlist",
        "publicStats": "Stats",
        "publicWishlist": "%{user} Wishlist",
        "resetIngame": "Reset Ingame Ships after Wipe",
        "imports": "Imports"
      },
      "syncExtension": "Sync RSI Hangar",
      "editMyVehicle": "Edit my %{vehicle}",
      "nameMyVehicle": "Name my %{vehicle}",
      "editGroups": "Edit Groups",
      "newVehicles": "Add Ships",
      "myVehicleAddons": "Add Modules / Upgrades for %{vehicle}",
      "myVehicleLoadouts": "Loadouts for %{vehicle}",
      "addToHangar": "Add \"%{model}\" to your Hangar",
      "impressum": "Impressum",
      "privacy": "Privacy policy",
      "cookie": "Cookie policy",
      "requestPassword": "Request Password",
      "changePassword": "Change Password",
      "confirmAccess": "Confirm access",
      "setEmail": "Set your email address",
      "oauthAuthorize": "Authorize Application",
      "filterModels": "Filter Ships",
      "filterVehicles": "Filter Hangar",
      "fleets": {
        "owners": "Owners",
        "add": "Create a new Fleet",
        "invites": "Fleet Invites",
        "inviteUrls": "Invite Urls",
        "members": {
          "index": "Members",
          "worldmap": "Member Worldmap",
          "starmap": "Member Starmap"
        },
        "squadrons": {
          "index": "Squadrons",
          "create": "Create Squadron",
          "edit": "Edit Squadron",
          "formDetails": "Details",
          "formAppearance": "Appearance",
          "formDiscord": "Discord",
          "teams": "Teams",
          "addMembers": "Add Members",
          "members": "Members"
        },
        "stats": "Stats",
        "preview": {
          "h1": "Fleet Preview",
          "h2": "To create a Fleet you need to have a FleetYards.net Account",
          "h3": "What Features does your Fleet include?"
        },
        "settings": {
          "fleet": "Fleet Settings",
          "membership": "Membership Settings",
          "roles": "Fleet Roles",
          "squadrons": "Fleet Squadrons",
          "allies": "Fleet Allies",
          "notifications": "Notification Settings",
          "inAppNotifications": "In-app Notifications",
          "discord": "Discord",
          "calendar": "Calendar",
          "contracts": "Contract Settings",
          "features": "Fleet Features"
        },
        "inviteMember": "Invite new Member",
        "calendarSubscription": "Calendar Subscription",
        "missions": {
          "index": "Missions",
          "create": "Create Mission",
          "edit": "Edit Mission",
          "editDetails": "Details",
          "editDescription": "Description & cover",
          "editTeams": "Teams & slots",
          "teams": "Teams",
          "ships": "Ships",
          "slots": "Slots",
          "addTeam": "Add Team",
          "editTeam": "Edit Team",
          "addShip": "Add Ship",
          "editShip": "Edit Ship"
        },
        "events": {
          "expandShip": "Add seats",
          "index": "Events",
          "calendar": "Calendar",
          "create": "Create Event",
          "edit": "Edit Event",
          "editDetails": "Details",
          "editSchedule": "Schedule",
          "editSignup": "Sign-up",
          "editDescription": "Description & cover",
          "editTeams": "Teams & slots",
          "spawn": "Spawn Event",
          "details": "Event Details",
          "schedule": "Schedule",
          "settings": "Settings",
          "lifecycle": "Lifecycle",
          "signupTitle": "Sign me up",
          "yourSignup": "Your signup",
          "spawnedFrom": "Spawned from this mission",
          "pickTemplate": "Pick a Mission Template",
          "unassignedSignups": "Unassigned signups",
          "eventTeam": "Event team",
          "grantRole": "Grant a role",
          "editTeam": "Edit team",
          "addTeam": "Add team",
          "editShip": "Edit ship",
          "addShip": "Add ship",
          "assignSlotFor": "Assign slot for %{username}",
          "reassignSlotFor": "Reassign slot for %{username}"
        },
        "memberNickname": "Member Nickname",
        "contracts": {
          "index": "Contracts",
          "create": "Create Contract",
          "edit": "Edit Contract",
          "progress": "Progress",
          "crew": "Crew",
          "items": "Goods",
          "editItem": "Edit goods",
          "addItem": "Add goods",
          "views": {
            "open": "Contracts",
            "closed": "Closed contracts",
            "mine": "My contracts",
            "completed": "Completed contracts"
          }
        }
      },
      "hangarGroup": {
        "create": "Create Group",
        "edit": "Edit Group"
      },
      "compare": {
        "ships": "Compare Ships"
      },
      "settings": {
        "account": "Account",
        "profile": "Profile Settings",
        "hangar": "Hangar Settings",
        "privacy": "Privacy Settings",
        "features": "Feature Flags",
        "connections": "Connections",
        "oauthApplications": "OAuth Applications",
        "notifications": "Notification Settings",
        "verify": "Verify your RSI Account",
        "security": {
          "index": "Account Security",
          "twoFactor": "Two-factor Authentication"
        },
        "twoFactor": {
          "enable": "Enable Two-factor Authentication",
          "disable": "Disable Two-factor Authentication",
          "backupCodes": "Generate Two-Factor Backup Codes"
        },
        "calendar": "Calendar Subscription",
        "donations": "Donations"
      },
      "oauthApplications": {
        "new": "New OAuth Application",
        "edit": "Edit OAuth Application"
      },
      "roadmap": "Ship-Roadmap",
      "tools": {
        "index": "Tools",
        "travelTimes": "Travel Times",
        "cargoGrids": "Cargo Grids"
      },
      "rsiVerification": "Verify your RSI-Account",
      "hangarGuideEmpty": "Not much to see here?",
      "hangarGuide": "Hangar Guide",
      "support": "Support FleetYards.net",
      "supporters": "Thanks to our supporters",
      "supportHint": {
        "hangarSync": "Glad we could help with your sync",
        "vehicleAdded": "Your hangar is growing",
        "fleetCreated": "A new fleet — nice!",
        "loginMilestone": "Thanks for sticking around",
        "visitMilestone": "Enjoying FleetYards?"
      },
      "vehicle": {
        "bulkGroupEdit": "Add/Remove Groups"
      },
      "pagination": {
        "count": "%{current} of %{total}"
      },
      "models": {
        "index": "Models"
      },
      "modals": {
        "models": {
          "displayOptions": "Display Options"
        }
      },
      "visualTests": {
        "overview": "Overview",
        "panels": "Panels",
        "buttons": "Buttons",
        "media": "Media",
        "charts": "Charts",
        "blueprints": "Blueprints",
        "squadrons": "Squadrons",
        "chips": "Visual Tests Chips",
        "events": "Events",
        "typography": "Typography",
        "forms": "Forms",
        "tables": "Tables",
        "lists": "Lists",
        "metrics": "Metrics",
        "states": "States",
        "notifications": "Notifications",
        "syncModal": "Sync Modal",
        "overlays": "Overlays",
        "supportHint": "Support Hint",
        "notificationCenter": "Notification Center",
        "themes": "Themes"
      },
      "logistics": {
        "index": "Logistics",
        "inventories": "Inventories",
        "requests": "Requests",
        "newRequest": "New Request",
        "requestItems": "Items",
        "comments": "Comments",
        "inventoryItems": "Inventory Items",
        "createInventory": "Create Inventory",
        "editInventory": "Edit Inventory",
        "createItem": "Add Item",
        "deposit": "Deposit",
        "withdrawal": "Withdrawal",
        "importCsv": "Import from CSV",
        "hangarInventories": "Hangar Inventories",
        "editItem": "Edit Entry",
        "editStockItem": "Edit Item",
        "transfer": "Transfer Stock",
        "transfers": "Transfers",
        "acceptTransfer": "Accept Transfer",
        "reportTransfer": "Report Transfer"
      },
      "notifications": {
        "index": "Notifications"
      },
      "payouts": {
        "index": "Payouts",
        "summary": "Summary",
        "participants": "Participants",
        "entries": "Entries",
        "balances": "Balances",
        "transfers": "Payout list",
        "addEntry": "Record money",
        "editEntry": "Edit entry",
        "addParticipant": "Add participant",
        "tours": {
          "index": "Tours",
          "create": "Create Tour",
          "join": "Join this tour"
        },
        "declineExpense": "Decline expense"
      },
      "relationships": {
        "user": {
          "index": "Friends",
          "add": "Add a friend"
        },
        "fleet": {
          "add": "Add an ally"
        }
      },
      "fleet": {
        "contractCovers": "Contract covers"
      },
      "component": {
        "history": "History",
        "craftedFrom": "Crafted from",
        "identity": "Details",
        "metrics": "Metrics",
        "requiredTags": "Fits a port offering",
        "tags": "Tags"
      },
      "commodity": {
        "priceHistory": "Price History",
        "identity": "Details",
        "usedIn": "Used In"
      },
      "commodities": {
        "index": "Commodities"
      },
      "components": {
        "index": "Components"
      },
      "blueprints": {
        "index": "Blueprints"
      },
      "missions": {
        "index": "Missions"
      },
      "missions": {
        "index": "Missions"
      },
      "equipment": {
        "index": "Equipment",
        "metrics": "Metrics",
        "identity": "Details",
        "craftedFrom": "Crafted from"
      }
    }
  }
}
